<template>
  <div class="flex-custom">
    <div class="item-merch-3__tab-wrapper">
      <template v-for="(item, i) in data">
        <a
          class="item-merch-3__tab-wrapper__tab"
          :class="{'active': i === selected}"
          href="javascript:;"
          @click="changeTab(i)"
        >
          {{ item.tab_name }}
        </a>
      </template>
    </div>

    <div class="item-merch-3__content-wrapper">
      <template v-for="(item, i) in data">
        <div
          class="item-merch-3__tab-content"
          :class="{'active': i === selected, 'data-loaded': item.merchLoaded}"
        >
          <div v-if="!item.merchLoaded || item.merch">
            <div class="splide">
              <div class="item-merch-3__banner-wrapper">
                <div class="item-merch-3__banner-wrapper__image">
                  <img
                    :src="item.banner_image"
                    alt=""
                    aria-hidden="true"
                    role="presentation"
                  >
                </div>
                <div class="item-merch-3__banner-wrapper__content">
                  <p class="item-merch-3__banner-wrapper__content__kicker">
                    {{ item.banner_kicker }}
                  </p>
                  <h2 class="item-merch-3__banner-wrapper__content__title">
                    {{ item.banner_title }}
                  </h2>
                  <p class="item-merch-3__banner-wrapper__content__description">
                    {{ item.banner_description }}
                  </p>
                  <a
                    v-if="item.banner_button"
                    class="btn-custom secondary"
                    :href="item.banner_link"
                  >
                    {{ item.banner_button }}
                  </a>
                </div>
              </div>
              <div class="splide__track">
                <ul
                  class="splide__list"
                  v-html="item.merch"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="item-merch-3__slider-empty"
          >
            <h5>No Products Available...</h5>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      selected: 0,
    };
  },
  mounted() {
    this.queryMerch(0);
  },
  updated() {
    const that = this;

    that.$el.querySelectorAll('.item-merch-3__tab-content.data-loaded .splide:not(.splide-initialized)').forEach((item) => {
      new Splide(item, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        gap: 30,
        arrows: false,
        pagination: true,
        autoplay: false,
        breakpoints: {
          1469: {
            perPage: 3,
            gap: 15,
          },
          1200: {
            perPage: 2,
          },
          991: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          550: {
            perPage: 1,
          },
        },
      }).mount();
      item.classList.add('splide-initialized');
    });

    // Remove RRP text from all RRP spans
    that.$el.querySelectorAll('.rrp span').forEach((rrpSpan) => {
      rrpSpan.textContent = rrpSpan.textContent.replace(/RRP\s*/i, '');
    });

    window.fetchLiveData();
  },
  methods: {
    changeTab(num) {
      this.selected = num;
      this.queryMerch(num);
    },
    queryMerch(num) {
      const that = this;

      if (this.data[num].merchLoaded) return;

      $.ajax({
        type: 'post',
        url: '/ajax/merchandising',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        data: {
          groupMerchandising_ids: [that.data[num].merch_id],
        },
        success(response) {
          // Needed to reset the script
          setTimeout(() => {
            document.querySelectorAll('.item-merch-3 .item-merch-3__content-wrapper .active script').forEach((script) => {
              const newScript = document.createElement('script');
              newScript.text = script.text;
              document.body.appendChild(newScript);
              document.body.removeChild(newScript);
            });
          });

          // used to add splide__slide to each tileparent
          const merchItems = response.data.itemmerchandisinghtml[that.data[num].merch_id];
          const doc = new DOMParser().parseFromString(merchItems, 'text/html');

          Array.from(doc.body.children).forEach((item) => item.classList.add('splide__slide'));

          Object.assign(that.data[num], {
            merch: doc.body.innerHTML,
            merchLoaded: true,
          });

          that.$forceUpdate();
        },
      });
    },
  },
};
</script>
